import { render, staticRenderFns } from "./ServiceDescriptionSetupFilters.vue?vue&type=template&id=1edb005e&scoped=true&"
import script from "./ServiceDescriptionSetupFilters.vue?vue&type=script&lang=js&"
export * from "./ServiceDescriptionSetupFilters.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDescriptionSetupFilters.vue?vue&type=style&index=0&id=1edb005e&prod&lang=scss&"
import style1 from "./ServiceDescriptionSetupFilters.vue?vue&type=style&index=1&id=1edb005e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edb005e",
  null
  
)

export default component.exports